export default __webpack_public_path__ + "static/media/day-7.17e071f9.jpg";